import { render, staticRenderFns } from "./segment-shared-with.vue?vue&type=template&id=0b1c68fa&"
import script from "./segment-shared-with.vue?vue&type=script&lang=js&"
export * from "./segment-shared-with.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports